import React, { useEffect, useMemo, useState, useRef } from "react";
import useLiveStreamsData from "./LiveStreamsData";
import { deleteVideo, getLibraryByCategory } from "../../api/HttpApis";
import { showToast } from "../../utils/Toastify/Toastify";
import { useLocation, useNavigate } from "react-router-dom";
import ListView from "../../component/ListView/ListView";
import { contentStats } from "../../component/ListView/contentCard";
import { trimStr } from "../../utils/theme/ShortenedText/ShortenedText";
import AddChannelPopUp from "../../component/AddChannelPopUp/AddChannelPopUp";
import { useSearch } from "../../context/SearchContext";
import FloatingButton from "../../component/FloatingButton/FloatingButton";

const LiveStreams = () => {
  const [liveStreamsData, setLiveStreamsData] = useState([]);
  const [showPopup, setShowPopup] = useState(false);
  const { liveStreamsListData, getCard } = useLiveStreamsData();
  const [deletingId, setDeletingId] = useState(null);
  const { searchQuery } = useSearch();
  const prevSearchQuery = useRef(searchQuery);
  const [selectedDate, setSelectedDate] = useState("");
  const [selectedCreator, setSelectedCreator] = useState("");
  const [selectedRating, setSelectedRating] = useState("");
  const [selectedGenre, setSelectedGenre] = useState();
  const [totalCount, setTotalCount] = useState(0);
    const [loading, setLoading] = useState(false);

  const navigate = useNavigate();
  const location = useLocation();
  const { liveStreams } = location.state || {};

  const fetchData = async (page, limit) => {
    if (searchQuery) return;
    setLoading(true);
    try {
      const response = await liveStreamsListData(
        selectedDate,
        selectedCreator,
        selectedRating,
        selectedGenre,
        page,
        limit
      );
      setLiveStreamsData(response);
      setTotalCount(Array.isArray(response) && response.length > 0 ? response[0].totalCount || 0 : 0);
    } catch (error) {
      showToast(error.response.data.message, "error");
    } finally {
      setLoading(false);
    }
  };

  const handleEdit = (id, metadata_id) => {
    // Use metadata_id in URL if available, otherwise use original id
    const urlId = metadata_id || id;
    const hasMetadataId = Boolean(metadata_id);
    const url = hasMetadataId ? `/video/${urlId}` : `/video/${urlId}?meta=false`;
    
    navigate(url, {
      state: {
        movieId: id, // Always pass original id for API calls
        metadata_id: metadata_id || "", // Include metadata_id in body parameters
      },
    });
  };

  const handleDelete = async (id, metadata_id) => {
    const confirmed = window.confirm(
      "Are you sure you want to delete this item?"
    );
    if (!confirmed) return;
    // Use metadata_id if available, otherwise use id (same as edit)
    const deleteId = metadata_id || id;
    setDeletingId(deleteId);
    try {
      const response = await deleteVideo(deleteId);

      setLiveStreamsData((prev) => prev.filter((item) => (item.metadata_id || item.id) !== deleteId));
      // Keep the Total tile in step without a refetch.
      setTotalCount((c) => Math.max(0, (Number(c) || 0) - 1));
      showToast(response.data.message, "success");
    } catch (error) {
      showToast(error.response.data.message, "error");
    } finally {
      setDeletingId(null);
    }
  };

  const cardFor = getCard(handleEdit, handleDelete, deletingId);
  const stats = contentStats(liveStreamsData, totalCount);
  const handleFilterChange = async (type, value) => {
    if (type === "genre") setSelectedGenre(value);
    if (type === "date") setSelectedDate(value);
    if (type === "creator") setSelectedCreator(value);
    if (type === "rating") setSelectedRating(value);

    const updatedGenre = type === "genre" ? value : selectedGenre;
    const updatedDate = type === "date" ? value : selectedDate;
    const updatedCreator = type === "creator" ? value : selectedCreator;
    const updatedRating = type === "rating" ? value : selectedRating;
        setLoading(true);

    try {
      const response = await getLibraryByCategory(
        "Live Stream",
        {},
        updatedDate,
        updatedCreator,
        updatedRating,
        updatedGenre,
        undefined,
        undefined,
        searchQuery
      );

      const data = Array.isArray(response?.data?.data)
        ? response.data.data
        : [];

      const formattedData = data.map((item) => ({
        id: item.id,
        metadata_id: item.metadata_id,
        name: trimStr(item.name),
        media: item.portrait,
        status: item.status,
        qc_status: item.qc_status,
        rating: item.rating,
        access: item.access,
        buttonText: "Edit",
        buttonText2: "Remove",
      }));

      setLiveStreamsData(formattedData);
      setTotalCount(response?.data?.total);
      showToast();
    } catch (error) {
      showToast("Failed to apply filter", "error");
    } finally {
      setLoading(false);
    }
  };
  const closePopup = () => {
    setShowPopup(false);
  };

useEffect(() => {
  if (prevSearchQuery.current === searchQuery) {
    return;
  }
  prevSearchQuery.current = searchQuery;

  const timer = setTimeout(() => {
    if (searchQuery === "" ||searchQuery ) {
      handleFilterChange("search", "");
    }
  }, 500);

  return () => clearTimeout(timer);
}, [searchQuery]);

 const handleAddEvent = () => {
   // setShowPopup(true);
   navigate(`/mainlayout/media-library/`, {
     state: {
       name: "Live Events",
     },
   });
 };
  return (
    <>
      {liveStreams || showPopup ? (
        <AddChannelPopUp onClose={closePopup} liveStreams={liveStreams} />
      ) : (
        <div>
          <ListView
            heading="Live Streams"
            data={liveStreamsData}
            getCard={cardFor}
            stats={stats}
            button={true}
            handleFilterChange={handleFilterChange}
            selectedDate={selectedDate}
            selectedRating={selectedRating}
            selectedGenre={selectedGenre}
            onPageChange={fetchData}
            totalCount={totalCount}
            tableLoading={loading}
            addLabel="New Event"
            onAdd={handleAddEvent}
          />
          <FloatingButton />
        </div>
      )}
    </>
  );
};

export default LiveStreams;